import axios from "axios";

const config = {
  method: "get",
  url: "https://cdn.moneyconvert.net/api/latest.json",
  headers: {},
};

export const currencyExchangeApi = axios(config);
